import { fetchJson } from '../helpers/fetch';
import {
  project_save_state_path,
  project_select_window_path,
  project_resolve_list_path,
  project_call_publish_evaluations_path,
  project_get_phase_decision_comments_path,
  project_bulk_add_project_files_tag_path,
  project_bulk_download_project_files_path,
  download_project_file_path,
  project_excel_export_legacy_path,
  project_excel_export_path,
  project_call_evaluation_result_data_path,
  project_evaluate_path,
  project_show_path,
  project_update_monitoring_status_path,
  project_unassign_evaluator_path,
  project_assign_evaluator_path,
  project_undo_evaluation_path,
  project_undo_submit_path
} from '~/routes'

export const Project = {
  pageLength: -1,
  saveState: function (options, state) {
    // Stores state information for excel export
    var element = jQuery('#store');
    if (element.length) {
      var store = JSON.parse(element.text());
      store.state = state;
      element.text(JSON.stringify(store));

      if (state.length && state.length != this.pageLength) {
        this.pageLength = state.length;
        jQuery.post(project_save_state_path( { page_length: state.length }) );
      }
    }
  },

  loadState: function (settings) {
    var element = jQuery('#store');
    if(settings && element.length) {
      var page_length = JSON.parse(element.text())["global_page_length"];
      settings._iDisplayLength = page_length;
      this.pageLength = page_length;
    }
    return settings;
  },
   
  show: function() {
    jQuery(".main").delegate('.project-window-edit', 'click', function() {
      jQuery('.project-window-title').hide();
      jQuery('.project-window-select, #change-project-window-cancel').show();
      jQuery('select#window_id').select2({minimumResultsForSearch: Infinity});
    });

    jQuery('.main').undelegate('#change-project-window-save', 'click');
    jQuery('.main').delegate('#change-project-window-save', 'click', function(e) {
      jQuery(this).hide().after(SmartME.loadingIndicator(20));
      jQuery('#change-project-window-cancel').hide();

      jQuery.ajax({
        url: project_select_window_path({
          project_id: jQuery('.project-window-select').data('project-id'),
          window_id: jQuery('#window_id').val()
        }),
        method: 'post'
      }).done(function(data){
        jQuery('.project-window-select .loading-indicator').remove();
        jQuery('#change-project-window-save').show();
        jQuery('.project-window-title').show();
        jQuery('.project-window-select').hide();
        jQuery('.project-window-title-content').text(data.title);
      });

      return false;
    });

    jQuery('.main').delegate('#change-project-window-cancel', 'click', function() {
      jQuery('.project-window-title').show();
      jQuery('.project-window-select').hide();
      return false;
    });

    jQuery('.main').undelegate('.delete-project-link', 'click');
    jQuery('.main').delegate('.delete-project-link', 'click', function(e) {
      var $link = jQuery(this);


      ExplanationDialog.open(function(explanation){
  
        jQuery.ajax({
          url: $link.attr('href'),
          method: 'POST',
          data: {explanation: explanation}
        }).done(function(){
          Turbo.visit(project_resolve_list_path({
            format: null,
            call_id: $link.data('project-call-id')
          }));
          ExplanationDialog.close()
        });
   
      }, '<p>' + I18n.t('delete_project_confirm') + '</p>');

      e.preventDefault();
      return false;
    });


    $('body').css('padding-bottom', '0');
    //$('.async-container.container-fluid').height(jQuery(window).height() - jQuery('.async-container.container-fluid').position().top - jQuery('.navbar').outerHeight());
    $('.async-container.container-fluid').css('overflow', 'auto');


    jQuery('body').delegate('.enable-editor', 'click', function(e) {
      var $link = jQuery(this);
      jQuery.ajax({
        url: $link.attr('href'),
        method: 'post'
      }).done(function(data) {
        $link.toggleClass('locked');
        $link.find('i').toggleClass('fa-lock', $link.is('.locked'));
        $link.find('i').toggleClass('fa-unlock', !$link.is('.locked'));
        $link.attr('href', $link.attr('href').replace(/(true|false)$/, ($link.is('.locked') ? 'true' : 'false')))
      });

      return false;
    })

    ActionJS.Project.priv.initProjectHeaderTabs();
  },

  prescoring: function() {
    $.ajax({
      url: jQuery('#project-form').data('url'),
      type: 'GET',
      async: true
    }).done(function(content) {
      jQuery('#project-form').html(content);
    });

    jQuery('.nav.navbar-nav.eval-nav li > a, .external-eval-back a').on('click', function (e) {
      if (jQuery(this).attr('href') == '#') {
        e.preventDefault();
        $.ajax({
          url: jQuery(this).data('url'),
          type: 'GET',
          async: true
        }).done(function (content) {
          jQuery('#project-form').html(content);
          ResizablePages.init();
          jQuery('.external-eval-back').addClass('hidden');
        });
      }
    });
  },

  prescoring_form: function() {
    var form = jQuery('#prescoring-form');
    var inputs = form.find('.form-component').find('input, select, textarea');
    var dropareas = form.find('.form-component .dropzone');

    // Disable all except the prescoring fields (unless the form is disabled)
    if (form.is('[data-disabled="false"]')) {
      inputs = inputs.not('.prescoring *');
      dropareas = dropareas.not('.prescoring *');
    }
    inputs.prop('disabled', true).attr('readonly', 'readonly');
    dropareas.each(function() { Dropzone.forElement(this).destroy(); });
    dropareas.css('opacity', 0.5);
    AdaliaForm.init('.resizable-page.evaluation');
    form.parent().scrollTop(0);
  },

  // This is only relevant for the form created with the FormEditor and this
  // is called on the ready-callback when the FormViewer is mounted.
  evaluation_form: function() {
    var form = jQuery('#evaluation-form');
    var inputs = form.find('.form-component').find('input, select, textarea').filter('.prescoring *');


    // Disable prescoring component fields
    inputs.prop('disabled', true).attr('readonly', 'readonly');

    AdaliaForm.init('.resizable-page.evaluation');
    form.parent().scrollTop(0);

    ActionJS.Project.priv.initProgressRequirement();

    AutoSave.init();
  
    // Disable prescoring attachment fields
    var dropzones = form.find('.form-component.evaluation .dropzone');
    dropzones.each(function() { Dropzone.forElement(this).destroy(); });
    dropzones.find('.btn, .dz-message').remove();
    dropzones.addClass('disabled', true);
  },

  history: function(){
    jQuery('.back-to-progress').on('click', function(){
      Turbo.visit(jQuery('ul.project-title-tabs a#progress').attr('href'));
      jQuery('.project-title-tabs').show();
      return false;
		});
		//when two checkboxes are checked, disable other check boxes
		jQuery(":checkbox[name='selected_application']").change(
			function(){
				if (jQuery(":checkbox[name='selected_application']:checked").length == 2){
					jQuery(':checkbox:not(:checked)').prop('disabled', true);
					jQuery('#compare-form-diff').prop('disabled', false);
				}
				else {
					jQuery(':checkbox:not(:checked)').prop('disabled', false);
					jQuery('#compare-form-diff').prop('disabled', true);
				}
			}
		)
		//request for form details when compare button is clicked
		jQuery("#compare-form-diff").on('click', function(e){
			let p = '?';
			jQuery(":checkbox[name='selected_application']:checked").each(function(){
				p+='selected[]=' + this.value + '&';
			});
			var url = jQuery(this).attr('url')+p;
			jQuery('#compare-form-diff').css('opacity', '80%').prop('disabled', true).text(I18n.t('loading'))
			$.ajax({
				url: url,
				type: 'GET',
				async: true
			}).done(function(content) {
				ActionJS.Project.priv.setProjectTabContent(content, '');//jQuery('.main')
			});
		})
	},
	
	//hightlight the diff.
	renderUpdatedFields: function() {

    if (jQuery('#form-diff').length < 1) {
      return;
    }

    var diff = JSON.parse(jQuery('#form-diff').text());

    if (diff !== null) {
      diff.forEach(function(d){
					let s = '';
					for(let i=0;i<d.key.length;i++){
            s=s+ '[name*="' + d.key[i] + '"]';
					};
					let old_form_elem = jQuery('#old-form '+s);
					let new_form_elem = jQuery('#new-form '+s);
					switch(d.type){
						case "remove":
							new_form_elem.length? new_form_elem.addClass('diff-delete'): old_form_elem.addClass('diff-delete');
							break;
						case "edit":
							new_form_elem.addClass('diff-edit');
							break;
						case "delete":
							new_form_elem.addClass('diff-delete');
							break;
						default:
							new_form_elem.addClass('diff-edit');
					};
          // remove highlight class for checkbox and radio for not related selection
          if (new_form_elem.length > 1){
            let current_diff = d.current
            if (Array.isArray(d.current)){
              current_diff = d.current.filter(v => d.previous === null || (Array.isArray(d.previous) && !d.previous.includes(v)))
            }

            for (let i=0;i<new_form_elem.length;i++){
              if (Array.isArray(current_diff)){
                if (!current_diff.includes(new_form_elem[i].value)){
                  jQuery(new_form_elem[i]).removeClass('diff-edit diff-delete')
                }
              } else {
                if (new_form_elem[i].value !== current_diff){
                  jQuery(new_form_elem[i]).removeClass('diff-edit diff-delete')
                }
              }
            }
          }
				}
      )
    }
	},
	
	//navigate between the forms
	show_form_diff: function(){
		jQuery('.project-form-tabs button').on('click', function(e){
			e.preventDefault;
			document.querySelectorAll(".concept-note-form").forEach(function(e){
				e.style.display = "none";
			})
			document.querySelectorAll("[data-name=\'" + jQuery(this).text() + "\']").forEach(function(a){
				a.style.display = "block";
			});
			document.querySelectorAll(".project-form-tabs button").forEach(function(e){
				e.classList.remove('active')
			});
			this.classList.add("active");
		})
	},

  evaluate: function() {
    jQuery('.concept-evaluation-form').delegate('[name$="[score]"]', 'change', function() {
      jQuery('.concept-evaluation-form .subscore').each(function(i,e) {
        var $subscore = jQuery(this);
        var sum = 0;

        jQuery.each($subscore.data('fields'), function(i,fieldName) {
          var field = jQuery('[name="evaluation['+fieldName+'][score]"]');
          var score = parseInt(field.val()) * field.data('weight');
          sum = sum + score;
        });

        $subscore.find('.value').text(sum);
      });
    });

    // Attachment delete
    // jQuery('.concept-evaluation-form').append('<input type="hidden" value="" name="evaluation[attachments][deleted]" />');
    // var deletedAttachmentsInput = jQuery('.concept-evaluation-form').find('input[name="evaluation[attachments][deleted]"]');

    // var markDeletedFile = function(attachmentAttribute) {
    //   deletedAttachmentsInput.val(deletedAttachmentsInput.val().split(',').concat([attachmentAttribute]).join(',').replace(/^,/, ''));
    // }

    // var unmarkDeletedFile = function(attachmentAttribute) {
    //   deletedAttachmentsInput.val(deletedAttachmentsInput.val().replace(new RegExp(attachmentAttribute + ',?'), ''));
    // }

    // require recommend_proceeding
    jQuery('body').delegate('[name="evaluation[recommend_proceeding]"],[name="evaluation[recommended]"]', 'change', ActionJS.Project.priv.initProgressRequirement);
    ActionJS.Project.priv.initProgressRequirement();

    $.ajax({
      url: jQuery('#project-form').data('url'),
      type: 'GET',
      async: true
    }).done(function(content) {
      jQuery('#project-form').html(content);
    });

    jQuery('.nav.navbar-nav.eval-nav li > a, .external-eval-back a').on('click', function(e) {
      if (jQuery(this).attr('href') == '#') {
        e.preventDefault();
        var name = jQuery(this).html();
        $.ajax({
          url: jQuery(this).data('url'),
          type: 'GET',
          async: true
        }).done(function (content) {
          jQuery('#project-form').html(content);
          ResizablePages.init();
          jQuery('.external-eval-back').addClass('hidden');

        });
      }
      });
  },

  list_legacy: function() {

    ActionJS.Project.priv.filteredProjectIds = null;
    ActionJS.Project.priv.selectedProjects = [];

    // EVALUATION
    if (jQuery('.project-call-phase.selected').is('.evaluation')) {
      $('.publish-evaluations').smartmeToggle();

      ActionJS.Project.priv.initEvaluationFilters();
      $('input[name^="evaluation_list_filter"]').on('change', function() {
        ActionJS.Project.priv.noteTable.ajax.reload();
      });

      ActionJS.Project.priv.initEvaluationList();
      $(window).off('resize', ActionJS.Project.priv.syncTitleWidths);
      $(window).on('resize', ActionJS.Project.priv.syncTitleWidths);
      ActionJS.Project.priv.syncTitleWidths();

      $(window).off('scroll', ActionJS.Project.priv.syncTitlePosition);
      $(window).on('scroll', ActionJS.Project.priv.syncTitlePosition);
      ActionJS.Project.priv.syncTitlePosition();
      ActionJS.Project.priv.initCustomSortIcons();
    }
    // FINAL
    else if (jQuery('.project-call-phase.selected').is('.final')) {
      ActionJS.Project.priv.initFinalProjectList();
    }
    // FORM
    else {
      if (jQuery('table.concept-notes').length)
         ActionJS.Project.priv.initDefaultProjectList();
    }

    $('.publish-evaluations').on('mousedown', function() {
      var element = $('input[name="evaluations_published"]');
      var checked = element.is(':checked');

      if (confirm(I18n.t(`${checked ? 'invisible' : 'visible'}_to_other_confirm`)))
        $.ajax({
          url: project_call_publish_evaluations_path({phase_id: $('.concept-notes').data('selected-phase-id')}),
          data: {published: !checked},
          type: 'post'
        }).error(function(resp) {
          alert('error');
        }).done(function() {
            element.click();
            element.prop('checked', !checked);
        });
      else {
        return false
      }
    });

    //Bulk AI evaluate
    jQuery('#bulk_ai_evaluate').off('click').on('click', function() {
      var link = $(this);
      var projectIds = ActionJS.Project.priv.selectedProjects.map(v => v['id']);

      handleBulkAIEvaluate(link, projectIds)
      return false;
    });

    // Bulk email
    jQuery('#send-bulk-email').off('click').on('click', function() {
      var link = $(this);
      var projectIds = null;
      
      if (!ActionJS.Project.priv.filteredProjectIds) {
        var rowData = ActionJS.Project.priv.noteTable.rows({ filter: 'applied' }).data();
        projectIds = rowData.map(function(data) { return data[0].id; }).toArray();
      }
      else {
        projectIds = ActionJS.Project.priv.filteredProjectIds;
      }
      handleBulkEmail(link, projectIds)

      return false;
    });

    // Bulk edit explanation text
    jQuery('#edit-bulk-explanation-text').off('click').on('click', function() {
      var link = $(this);
      var noteIds = [];

      if (jQuery('table.concept-notes').length)
        noteIds = getSelectedRows().map(currentRowData => currentRowData[1].id);
      else
        noteIds = ActionJS.Project.priv.selectedProjects.filter(v => v.actions.decision_status === 'undecided').map(v => v['id']);

      if (noteIds.length === 0){
        alert(I18n.t('error_no_selected_unprocessed_projects'))
        return false;
      }

      var dialog = jQuery('#modal-dialog');
      var modalBody = dialog.find('.modal-body');
      dialog.find('.modal-footer').hide();
      dialog.find('.modal-title').html(link.data('title'));
      modalBody.html(SmartME.loadingIndicator());
      dialog.modal();
      jQuery.ajax({
        url: link.attr('href'),
        method: 'POST',
        dataType: 'html',
        data: { note_ids: noteIds }
      }).done((dialogContent) => {
        modalBody.html(dialogContent);  
      });
      dialog.trigger('modal:opened');
      return false;
    });

    // Bulk proceed all applications
    jQuery('#bulk-selected-proceed').off('click').on('click', function() {
      var link = $(this);
      handleBulkDecision(link, 'proceed')
      return false;
    });

    // Bulk drop all applications
    jQuery('#bulk-selected-drop').off('click').on('click', function() {
      var link = $(this);
      handleBulkDecision(link, 'drop')
      return false;
    });

    function getSelectedRows(){
      var visibleRows = ActionJS.Project.priv.noteTable.rows().nodes()

      var selectedRows = [];

      // Iterate through the row nodes
      visibleRows.each(function(node) {
        if ($(node).hasClass('selected')) { // Check for "selected" class
          var rowData = ActionJS.Project.priv.noteTable.row(node).data();
          selectedRows.push(rowData);
        }
      });
      return selectedRows
    }

    // Bulk selected email
    jQuery('#send-bulk-selected-email').off('click').on('click', function() {
      var link = $(this);
      var projectIds = null;

      if (jQuery('table.concept-notes').length)
        if (!ActionJS.Project.priv.filteredProjectIds) {
          var rowData = ActionJS.Project.priv.noteTable.rows({ filter: 'applied' }).data();
          projectIds = rowData.map(function(data) { return data[0].id; }).toArray();
        }
        else {
          projectIds = getSelectedRows().map(currentRowData => currentRowData[1].id);
        }
      else
        projectIds = ActionJS.Project.priv.selectedProjects.map(v => v['id']);

      handleBulkEmail(link, projectIds)
      return false;
    });

    // Bulk selected email
    jQuery('#send-bulk-email-all').off('click').on('click', function() {
      var link = $(this);
      handleBulkEmailAll(link)
      return false;
    });


    function getFinalDecision(decisionStr) {
      var finalDecision;

      if ([I18n.t('proceeding'), 'accepted'].includes(decisionStr))
        finalDecision = 'proceeding';
      else if ([I18n.t('dropped'), 'rejected'].includes(decisionStr))
        finalDecision = 'dropped';
      else
        finalDecision = 'undecided';

      return finalDecision;
    }

    function handleBulkDecision(link, action) {
      const predefinedDecisions = ["proceeding", "dropped"];
      var selectedRows = [];

      if (jQuery('table.concept-notes').length) {
        selectedRows = getSelectedRows().map(currentRowData => {
          let finalDecision = getFinalDecision(currentRowData[currentRowData.length - 2]);
          return {project_id: currentRowData[1].id, title: currentRowData[2], decision: finalDecision}
        });
      }
      else
        selectedRows = ActionJS.Project.priv.selectedProjects.map(currentRowData => {
          let finalDecision = getFinalDecision(currentRowData.decision_status['label']);
          return {project_id: currentRowData.id, title: currentRowData.project_title['label'], decision: finalDecision}
        });

      // Error when any selected projects decisions are made already.
      var decisions = selectedRows.map(project => project.decision)
      if (decisions.some(decision => predefinedDecisions.includes(decision))){
        var titlesDecided = selectedRows.filter(project => predefinedDecisions.includes(project.decision))
        alert(I18n.t('error_selected_projects_decided') + '\n' + titlesDecided.map(e=>e.title).join('\n'))
        return false;
      }

      const selectedNoteIds = selectedRows.map(row=>row.project_id)
      if (selectedNoteIds.length == 0) {
        alert(I18n.t(action == 'proceed' ? 'error_message_select_proceeding_application' : 'error_message_select_dropping_application'))
        return false;
      }

      jQuery.ajax({
        url: project_get_phase_decision_comments_path({phase_id: link.attr('data-phase-id')}),
        method: 'POST',
        dataType: 'json',
        data: { note_ids: selectedNoteIds }
      }).done(function(res) {
          const projectPhaseStatusNotInitialized = selectedNoteIds.filter(id => !res.comments.map(c => c.project_id).includes(id))
          const projectBlankDecisions = res.comments.filter(project => project.decision_explanation == null)
          const projectWithoutDecisions = projectPhaseStatusNotInitialized.concat(projectBlankDecisions)
          // Error when project have blank explanation or the explanation not exist in the db yet (because the project just proceed from previous stage)
          if (projectWithoutDecisions.length > 0){
            const projectWithoutDecisionsTitles = []
            selectedRows.map(project => {
              if (projectWithoutDecisions.includes(project.project_id)){
                projectWithoutDecisionsTitles.push(project.title)
              }
            })
            alert(I18n.t('error_selected_projects_not_have_explanation') + '\n' + projectWithoutDecisionsTitles.join('\n'))
            return;
          }

          var dialog = jQuery('#modal-dialog');
          var modalBody = dialog.find('.modal-body');
          var primaryButton = dialog.find('.modal-footer button.btn-primary');
          dialog.find('.modal-footer').show();
          dialog.find('.modal-title').html(link.data('title'));
          modalBody.html(SmartME.loadingIndicator());
          primaryButton.html(I18n.t('confirm'));

          dialog.modal();

          jQuery.ajax({
            url: link.attr('href'),
            method: 'POST',
            dataType: 'html',
            data: { applicants: selectedRows }
          })
          .done(function(dialogContent) {
            modalBody.html(dialogContent);      
          });
          dialog.trigger('modal:opened');
        });
    }

    function handleBulkAIEvaluate(link, projectIds) {
      if(projectIds.length === 0) {
        alert(I18n.t('empty_eval_selection'))
        return;
      }
      jQuery.ajax({
        url: link.attr('href'),
        method: 'POST',
        dataType: 'html',
        data: {project_ids: projectIds}
      }).done(function() {
        alert(I18n.t('projects_queued_for_evaluation'));
      });
    }

    function handleBulkEmailAll(link) {
      var dialog = jQuery('#modal-dialog');
      var modalBody = dialog.find('.modal-body');
      var primaryButton = dialog.find('.modal-footer button.btn-primary');
      dialog.find('.modal-footer').show();
      dialog.find('.modal-title').html(link.data('title'));
      modalBody.html(SmartME.loadingIndicator());
      primaryButton.html(link.attr('data-save-label'));
      primaryButton.button('reset').removeAttr('disabled');
      
      dialog.modal();

      jQuery.ajax({
        url: link.attr('href'),
        method: 'POST',
        dataType: 'html',
      })
      .done(function(dialogContent) {
        modalBody.html(dialogContent);
        
        primaryButton.off('click').on('click', function() {
          jQuery(this).button('loading');
          if (confirm(I18n.t('bulk_email_confirm_message', { recipient_count: $('#applicants-count-info').data('applicants-count') }))) {
            var form = modalBody.find('form');
            jQuery.ajax({
              url: form.attr('action'),
              method: 'POST',
              dataType: 'html',
              data: form.serialize()
            })
            .done(function(dialogContent) {
              modalBody.html(dialogContent);
              if (dialog.find('.form-errors').length) {
                primaryButton.button('reset').removeAttr('disabled');
              } else
                  dialog.find('.modal-footer .btn-primary').hide();
            });
            return false;
          } else {
            jQuery(this).button('reset');
          }
        });
      });

      dialog.trigger('modal:opened');
    }

    function handleBulkEmail(link, projectIds,){
      var dialog = jQuery('#modal-dialog');
      var modalBody = dialog.find('.modal-body');
      var primaryButton = dialog.find('.modal-footer button.btn-primary');
      dialog.find('.modal-footer').show();
      dialog.find('.modal-title').html(link.data('title'));
      modalBody.html(SmartME.loadingIndicator());
      primaryButton.html(link.attr('data-save-label'));
      primaryButton.button('reset').removeAttr('disabled');
      
      dialog.modal();

      jQuery.ajax({
        url: link.attr('href'),
        method: 'POST',
        dataType: 'html',
        data: {
          project_ids: projectIds,
          filters: ActionJS.Project.priv.noteTableFilters || {} }
      })
      .done(function(dialogContent) {
        modalBody.html(dialogContent);

        function observe_dropdown_menu() {
          var updateRecipientCount = function() {
            jQuery('.recipient-count').html(jQuery('.bulk-email-recipient-list input:checked').length);
          };
          jQuery('a.recipient-select').on('click', function() {
            var link = jQuery(this);
            var linkType = ['all', 'none', 'owner', 'partner'].filter(function (e) {
            return link.attr('class').split(' ').indexOf(e) >= 0 })[0];
            jQuery('.bulk-email-recipient-list input').each(function() {
              jQuery(this).prop('checked', linkType === 'all' || jQuery(this).hasClass(linkType));
            })
            updateRecipientCount();
          });
          jQuery('.bulk-email-recipient-list').on('click', 'input', updateRecipientCount);
        }
        observe_dropdown_menu();
        
        primaryButton.off('click').on('click', function() {
          jQuery(this).button('loading');
          if (confirm(I18n.t('bulk_email_confirm_message', { recipient_count: jQuery('.bulk-email-recipient-list input:checked').length }))) {
            var form = modalBody.find('form');
            jQuery.ajax({
              url: form.attr('action'),
              method: 'POST',
              dataType: 'html',
              data: form.serialize()
            })
            .done(function(dialogContent) {
              modalBody.html(dialogContent);
              if (dialog.find('.form-errors').length) {
                primaryButton.button('reset').removeAttr('disabled');
                observe_dropdown_menu();
              } else
                  dialog.find('.modal-footer .btn-primary').hide();
            });
            return false;
          } else {
            jQuery(this).button('reset');

          }
        });
      });

      dialog.trigger('modal:opened');
    }


    $("#applicants-count-info").html(I18n.t('loading'));

    this.initBetaModalFunc();

    // Progress chart
    jQuery('.evaluation-progress-chart .chart').each(function() {
      var chartContainer = jQuery(this);
      chartContainer.find('canvas, .value').remove();
      var canvas = jQuery('<canvas width="200" height="200"></canvas>').appendTo(chartContainer);
      var ctx = canvas.get(0).getContext('2d');
      var values = JSON.parse(chartContainer.attr('data-values'));

      new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: [],
          datasets: [{
            data: values.total_count > 0 ? [
              values.unrecommended_count,
              values.recommended_count,
              values.tie_count,
              values.undefined_count
            ] : [1],
            backgroundColor: values.total_count > 0 ? [
              '#cd6466',
              '#88ad77',
              '#a3a3a3',
              '#f6f6f8'
            ] : ['#f6f6f8'],
            borderWidth: 0
          }]
        },
        options: {
          cutoutPercentage: 75,
          legend: { display: false }
        }
      });
      chartContainer.append('<div class="total">' + I18n.t('total') + '<div class="value">' + values.total_count + '</div></div>');
      chartContainer.attr('title', chartContainer.parent().find('.legend').html()).tooltip({
        placement: 'right',
        html: true
      });
    });

    ActionJS.Project.priv.initRevertSubmit(function(elem) {
      elem.closest('td').html(I18n.t('concept_note_status_draft'));
    });

    $('[data-toggle="tooltip"]').tooltip();
  },

  form: function() {
    var initCountdown = function() {
      var $counter = jQuery('.countdown-to-deadline');
      if ($counter.length === 0) return;

      var $days = $counter.find('.days .countdown-value');
      var $hours = $counter.find('.hours .countdown-value');
      var $minutes = $counter.find('.minutes .countdown-value');
      var $seconds = $counter.find('.seconds .countdown-value');

      var until = dayjs($counter.data('countdown-to-time-utc')).utc();
      
      var interval = setInterval(function() {
        var seconds = until.diff(dayjs().utc(), 'seconds'),
          days = 0,
            hours = 0,
            minutes = 0;

        if (seconds > 0) {
          days = Math.floor(seconds / (60 * 60 * 24));
          seconds -= days * (60 * 60 * 24);
          hours = Math.floor(seconds / (60 * 60));
          seconds -= hours * (60 * 60);
          minutes = Math.floor(seconds / 60);
          seconds -= minutes * 60;
          seconds = Math.floor(seconds);
        } else {
          seconds = 0;
        }

        $days.html(days);
        $hours.html(hours);
        $minutes.html(minutes);
        $seconds.html(seconds);
      }, 1000);

      var cleanup = function() {
        clearInterval(interval);
        jQuery(document).off('page:before-unload', cleanup);
      };

      jQuery(document).on('page:before-unload', cleanup);
    };

    initCountdown();
  },


  edit_data_sheet: function() {
    jQuery('input.datetimepicker').flatpickr({dateFormat: 'Y-m-d', allowInput: true});

    // Format currencies on load
    jQuery('input[data-currency-format]').each(function(){
      var unformatted = jQuery(this).val();

      if (unformatted.length > 0) {
        jQuery(this).data('unformatted-val', unformatted);
        jQuery(this).val(SmartME.formatCurrency(unformatted, jQuery(this).data('currency-format')))
      }
    });

    // Unformat on focus
    jQuery('input[data-currency-format]').on('focus', function(){
      jQuery(this).val(jQuery(this).data('unformatted-val'));
    });

    // Format on blur
    jQuery('input[data-currency-format]').on('blur', function(){
      var unformatted = jQuery(this).val();

      if (unformatted.length > 0) {
        jQuery(this).data('unformatted-val', unformatted);
        jQuery(this).val(SmartME.formatCurrency(unformatted, jQuery(this).data('currency-format')))
      }
    });

    // Unformat on submit. Store the unformatted value.
    jQuery('#project-data-sheet-form').on('submit', function(){
      jQuery('input[data-currency-format]').each(function(){
        if (jQuery(this).val().length > 0) {
          jQuery(this).val(jQuery(this).data('unformatted-val'));
        }
      });
    });
  },

  update_data_sheet: function(){
    ActionJS.Project.edit_data_sheet();
  },

  edit_project_file_tags: function() {
    jQuery('#file-tags').select2({
      tags: jQuery('#file-tags').data('available-tags')
    })

    jQuery('input.select2-input').on('input', function(){
      $(this).val($(this).val().toUpperCase());
    })
  },

  list_internal_files: function(){
    ActionJS.Project.priv.selectedInternalFileIds = [];

    jQuery('#bulk-edit-button').on('click', function(){
        var files_id = ActionJS.Project.priv.selectedInternalFileIds;

        if (files_id.size > 0){
          let project_id = jQuery('#internal-file-bulk-link').data('project-id')
          let old_href = jQuery('#internal-file-bulk-link').attr('href')
          let href = project_bulk_add_project_files_tag_path({project_id: project_id, type: 'project_internal_file'}) + '?' + jQuery.param({files_id: [...files_id]})
          jQuery('#internal-file-bulk-link').attr('href', href)
          jQuery('#internal-file-bulk-link').trigger('click')
          jQuery('#internal-file-bulk-link').attr('href', old_href)
        }else{
          alert(I18n.t('no_file_selected'))
        }
    })

    jQuery('#internal-file-bulk-download-button').on('click', function(){
        var files_id = ActionJS.Project.priv.selectedInternalFileIds;

        if (files_id.size > 0){
         if (confirm(I18n.t('confirm_download_files'))) {
          let link_ele = jQuery('#internal-file-bulk-download-link')
          let project_id = link_ele.data('project-id')
          let href = project_bulk_download_project_files_path({project_id: project_id, type: 'internal'}) + '?' + jQuery.param({files_id: [...files_id]})
          link_ele.attr('href', href)
          // $('a.shared-file-bulk-download-link')[0].click()
          $('#internal-file-bulk-download-link')[0].click()
         }
        } else
          alert(I18n.t('no_file_selected'))
    })
    
    if(jQuery('#internal-file-upload').length > 0){
      var dz = new Dropzone('#internal-file-upload', {
        url: jQuery('#internal-file-upload').data('url'),
        headers: {"X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr('content')},
       // maxFiles: 1,
       // acceptedFiles: 'image/*',
        addRemoveLinks: true
      });
  
      dz.on('success', function(file,res){
        // Replace the version text of the newly added file on version history
        var newlyAdded = jQuery('#internal-file-list > li:first-child');
        // Remove from upload zone.
        window.setTimeout(function(){
          dz.removeFile(file);
          jQuery(newlyAdded).removeClass('new');
        }, 2000);
      })
  
      dz.on('queuecomplete', function(file, res){
        Turbo.visit(location.href, {action: 'replace'});
      })
    }

    jQuery(document).on('click', '.internal-file-delete', function(e){
      e.stopPropagation();

      jQuery.ajax({
        url: jQuery(this).attr('href'),
        method: 'POST',
        headers: {"X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr('content')},
      }).done(function(d){
        Turbo.visit(location.href, {action: 'replace'});
      });

      e.preventDefault();
    });
  },

  list_files: function(){
    ActionJS.Project.priv.selectedSharedFileIds = [];

    jQuery('#shared-file-bulk-edit-button').on('click', function(){
        var files_id = ActionJS.Project.priv.selectedSharedFileIds;

        if (files_id.size > 0){
          let project_id = jQuery('#shared-file-bulk-link').data('project-id')
          let old_href = jQuery('#shared-file-bulk-link').attr('href')
          let href = project_bulk_add_project_files_tag_path({project_id: project_id, type: 'project_shared_file'}) + '?' + jQuery.param({files_id: [...files_id]})
          jQuery('#shared-file-bulk-link').attr('href', href)
          jQuery('#shared-file-bulk-link').trigger('click')
          jQuery('#shared-file-bulk-link').attr('href', old_href)
        }else{
          alert(I18n.t('no_file_selected'))
        }
    })

    jQuery('#shared-file-bulk-download-button').on('click', function(){
        var files_id = ActionJS.Project.priv.selectedSharedFileIds;

        if (files_id.size > 0){
         if (confirm(I18n.t('confirm_download_files'))) {
          let link_ele = jQuery('#shared-file-bulk-download-link')
          let project_id = link_ele.data('project-id')
          let href = project_bulk_download_project_files_path({project_id: project_id, type: 'shared'}) + '?' + jQuery.param({files_id: [...files_id]})
          link_ele.attr('href', href)
          // $('a.shared-file-bulk-download-link')[0].click()
          $('#shared-file-bulk-download-link')[0].click()
         }
        } else
          alert(I18n.t('no_file_selected'))
    })

    if(jQuery('#project-file-upload').length > 0){
      var dz = new Dropzone('#project-file-upload', {
        url: jQuery('#project-file-upload').data('url'),
        headers: {"X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr('content')},
       // maxFiles: 1,
       // acceptedFiles: 'image/*',
        addRemoveLinks: true
      });
  
      dz.on('success', function(){
        Turbo.visit(location.href, {action: 'replace'});
      })
    }

    jQuery(document).on('click', '.shared-file-delete', function(e){
      e.stopPropagation();
      var elem = jQuery(this);
      jQuery.ajax({
          url: elem.attr('href'),
          method: 'POST',
          headers: {"X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr('content')},
      }).done(function(d){
          Turbo.visit(location.href, {action: 'replace'});
      });

      e.preventDefault();
    });

    jQuery('[data-tooltip]').tooltip();
  },

  fillPhaseSummary: function(){
    jQuery('.show-form, .project-history, .edit-decision-message').on('click', function(e){
      e.preventDefault();
      var url = jQuery(this).attr('href');
      var name = jQuery(this).html();

      $.ajax({
          url: url,
          type: 'GET',
          async: true
        }).done(function(content) {
          ActionJS.Project.priv.setProjectTabContent(content, '');
          jQuery('.sub-content').html(content);
          jQuery('.external-eval-back').removeClass('hidden');
      });
    });
  },

  phasesSummary: function() {
    const link = document.querySelector('.del-ai-eval-icon');
    if(link){
      link.addEventListener('click', event => {
        event.preventDefault();
        const confirmMsg = link.dataset.confirmDelete;

        if (!confirm(confirmMsg)) return;
        fetchJson(link.dataset.deleteUrl, { method: 'POST', rejectBadRequest: true})
          .then(res => {
            const evalEl = document.getElementById('ai-evaluation');
            if (evalEl) {
              evalEl.remove();
            }
          })
          .catch(async error => {
            const errorBody = await error.json();
            const message = errorBody.error || 'Could not delete evaluation. Please try again.';
            alert(message);
          }
        );
      });
    }

    jQuery('table.phases-summary').find('.evaluator, a.attachment').tooltip({
      container: 'body'
    });
    jQuery('[data-toggle="tooltip"]').tooltip();

    // var phaseId = '#' + window.location.pathname.split('/').pop();
    // var barOffset = $(phaseId).offset().top - $('#progress').offset().top;
    // document.getElementById("progress").scrollTop = barOffset;

    jQuery('.show-form, .project-history, .edit-decision-message').on('click', function(e){
      e.preventDefault();
      var self = jQuery(this);
      var url = self.attr('href');

      $.ajax({
          url: url,
          type: 'GET',
          async: true
        }).done(function(content) {
          ActionJS.Project.priv.setProjectTabContent(content, '');
          jQuery('#project-form').html(content);
          jQuery('.external-eval-back').removeClass('hidden');

          if (self.attr('data-show-tabs')) {
            jQuery('.project-title-tabs').show();
          }
      });
    });

    jQuery('.application-zip-download').on('click', function(e){
      e.preventDefault();
      var a = jQuery(this);
     if (confirm(a.attr('data-confirm'))) {
      jQuery.get(a.attr('href'), function() {
          // success
      });
      window.ToastNotification({message: I18n.t('export_started_background_info'), horizontal: 'center', vertical: 'top', autoHideDuration: 5})
     }

     return false;
    });

    // Need to remove the class as the dialog is reused
    jQuery('.modal-dialog').on('click', '.dialog-close', function(){
      jQuery('.modal-dialog').removeClass('download-zip-dialog');
    });


    jQuery('a.clear-phase-status').on('click', function() {
      var a = jQuery(this);

      ExplanationDialog.open(function(explanation){
        jQuery.post(a.attr('href'), {explanation: explanation}, function() {
          jQuery('.project-title-tabs .selected a').trigger('click');
        }).done(function(content) {
          ExplanationDialog.close()
        })
      }, '<p>' + a.data('confirm') + '</p>')  

      return false;
    });

    // jQuery('table.phases-summary').on('click', '.undo-evaluation-submit', function(e) {
    //   if (confirm(I18n.t('undo_evaluation_submit_confirm'))) {
    //     var link = jQuery(this);
    //     jQuery.ajax({
    //       url: project_undo_evaluation_path({
    //         project_id: link.data('project-id'),
    //         content_id: link.data('content-id')
    //       }),
    //       method: 'post'
    //     }).done(function(data) {
    //       link.closest('td').html(I18n.t('evaluation_status_draft'));
    //     });
    //   }

    //   e.preventDefault();
    //   return false;
    // });

    ActionJS.Project.priv.initRevertSubmit(function(){
      window.location = window.location
    });

  },


  discardAutoSave: function(){
    $.ajax({
        url: jQuery('form.autosave').data('reload'),
        type: 'GET',
        data: {'autosave': false, 'editable': true},
        async: true
      }).done(function(content) {
        ActionJS.Project.priv.setProjectTabContent(content, '');
    });
  },


  messageComposition: function(){
    $('[data-toggle="tooltip"]').tooltip();

    jQuery('.project-title-tabs').removeClass('selected').hide();


    jQuery('.copy-comment').on('click', function(e){
      e.preventDefault();
      jQuery(this).tooltip('hide');

      var comment = jQuery(this).closest('.text').find('p').text();
      // Copy only highlighted
      var selection = window.getSelection();
      if (selection.toString().length > 0){
        if (comment.indexOf(selection.toString()) !== -1) {
          comment = selection.toString();
        }
      }

      var textarea = jQuery('#decision_explanation');
      
      if (textarea.val().lastIndexOf('\n\n') >= textarea.val().length - 2){
        textarea.val(textarea.val() + comment + '\n');
      } else if (textarea.val().lastIndexOf('\n') == textarea.val().length - 1){
        textarea.val(textarea.val() + '\n' + comment + '\n');
      } else {
        textarea.val(textarea.val() + '\n\n' + comment + '\n');
      }
    });

    jQuery('.actions .cancel').on('click', function(){
      var redirect = jQuery(this).data('redirect');

      if (redirect) {
        window.location = redirect;
      } else {
        jQuery('#modal-dialog').modal('hide');
      }

      jQuery('ul.project-title-tabs a#progress').trigger('click');
      jQuery('.project-title-tabs').show();
    });

    jQuery('.back-to-progress').on('click', function(){
      jQuery('ul.project-title-tabs a#progress').trigger('click');
      jQuery('.project-title-tabs').show();
    });


    jQuery('.actions .submit').on('click', function(){
      var currentBTN = jQuery(this);
      currentBTN.prop('disabled', true);

      var form = jQuery('#update-decision-comment');

      jQuery.post(form.attr('action'), form.serialize())
        .done(function(){
          jQuery('ul.project-title-tabs a.async:eq(1)').trigger('click');

          let redirect = currentBTN.data('redirect');
          if (redirect) {
            window.location = redirect;
          }
        })
        .fail((res) => {
          let responseJSON = res.responseJSON ? res.responseJSON.errors : {explanation: [{message: I18n.t('unexpected_error')}]};
          let modalBody = form.closest('.modal-body');

          if (modalBody.find('.alert').length == 0) {
            modalBody.prepend('<div class="alert alert-danger">' + responseJSON.explanation[0].message + '</div>');
          }
          currentBTN.removeAttr('disabled');
        })
    });

    jQuery('#attachment-dropdown .dropdown-menu li').on('click',function(e){
      var ta = jQuery(this).closest('.explanation-container').find('textarea')
      ta.val(ta.val() + ' ' + location.protocol + '//' + location.hostname + download_project_file_path({file_id: jQuery(this).find('a').data('id'), project_id: jQuery(this).find('a').data('projectid'), format: null}) + ' ');
    });
  },

  initForm: function(){
    jQuery('.async-container').off('click').on('click', '.edit-form, .cancel-form-edit', function(e){
      e.preventDefault();
      var link = jQuery(this);

       $.ajax({
        url: link.attr('href'),
        type: 'GET',
        async: true
      }).done(function(content) {
        ActionJS.Project.priv.setProjectTabContent(content, link.data('target'));
        jQuery(window).scrollTop(0);
      });

      return false;
    });

    jQuery('.back-to-progress').on('click', function(){
      jQuery('ul.project-title-tabs a#progress').trigger('click');
      jQuery('.project-title-tabs').show();
    });
  },

  initFormEdit: function(){
    jQuery('.concept-note-form').submit(function(e){
      
      e.preventDefault();
      var form = jQuery(this);
      ExplanationDialog.open(function(explanation){

        $.ajax({
          url: form.attr('action'),
          type: 'POST',
          data: form.serialize() + '&explanation=' + encodeURI(explanation),
          async: true
        }).done(function(content) {
          ActionJS.Project.priv.setProjectTabContent(content, form.data('target'));
          jQuery(window).scrollTop(0);
          ExplanationDialog.close();
        });

      }, '<p>' + I18n.t('form_edit_reason') + '</p>');

      return false;
    });
  },

  initExcelExport: function() {

    if (jQuery('#form-data').length > 0){
      var form_data = JSON.parse(jQuery('#form-data').html());
      var section_template = jQuery('#section-template').html();
      var row_template = jQuery('#row-template').html();
    }

    var dialog = jQuery('.modal-content')
    var dialog_content = dialog.html();

    // Add list parameters to request
    jQuery('#excel-export-form').on('submit', function(e) {
      var store = JSON.parse(jQuery('#store').text());

      var currentPageArray = [];
      var currentPageData = $('.concept-notes').DataTable().rows({ page: 'current' }).data();

      for (let i = 0; i < currentPageData.length; i++) {
        currentPageArray.push(currentPageData[i][1].id || currentPageData[i][0].id);
      }

      var params = $.param({store: store.state, project_ids: currentPageArray});
      var url = project_excel_export_legacy_path({call_id: store.cid, phase_id: store.pid, _options: true});
      jQuery.download(url, params, '#excel-export-form')


      // Empty the dialog after the post has been done.
      setTimeout(function(){  
        dialog.empty();
        dialog.append($("<p class='info-header'>"+ I18n.t('excel_export_started_info') + "</p>"));
        dialog.append($("<p class='info-text'>"+ I18n.t('export_started_background_info') + "</p>"));
        dialog.append($("<a data-dismiss='modal' class='dialog-close'>"+ I18n.t('close') + "</a>"));

      }, 500);
    });

    jQuery('#excel-export-form-ag-grid-v').on('submit', function(e) {
      var params = ActionJS.Project.priv.agGridParams || {};
      jQuery.download(project_excel_export_path({...params, _options: true}), $.param(params), '#excel-export-form-ag-grid-v');

      // Empty the dialog after the post has been done.
      setTimeout(function(){
        dialog.empty();
        dialog.append($("<p class='info-header'>"+ I18n.t('excel_export_started_info') + "</p>"));
        dialog.append($("<p class='info-text'>"+ I18n.t('export_started_background_info') + "</p>"));
        dialog.append($("<a data-dismiss='modal' class='dialog-close'>"+ I18n.t('close') + "</a>"));
      }, 500);
    });

    jQuery('.modal-content').on('click', '.dialog-close', function(){
      setTimeout(function(){
        dialog.html(dialog_content);
        initModalDialogs();
      }, 200)
    });

    jQuery('.modal-content').on('click', '.select-all', function(){
      jQuery(this).closest('div').find('input').prop('checked', true);
      jQuery(this).closest('div').find('.export-option').addClass('selected');
    });

    jQuery('.modal-content').on('click', '.deselect-all', function(){
      jQuery(this).closest('div').find('input').prop('checked', false);
      jQuery(this).closest('div').find('.export-option').removeClass('selected');
    });

     // Toggle by row click
    jQuery('#excel-export-form, #excel-export-form-ag-grid-v').on('click', '.export-option', function(){
      jQuery(this).toggleClass('selected');
      jQuery(this).find('input').prop('checked', jQuery(this).hasClass('selected'));
    });

    // Show question options on form selection (for multiple forms)
    jQuery('.form-selection .export-option').on('click', function() {
      var input = jQuery(this).find('input');
      var identifier = input.val();

      if (!input.prop('checked')){
        input.closest('form').append(
          section_template
          .replace('__title__', input.next().html())
          .replace('__id__', identifier)
        )

        var container = input.closest('form').find('#section-' + identifier)

        form_data[identifier].forEach(function(elem) {
          container.append(row_template.replace('__id__', elem['id']).replace('__label__', elem['value']))
        })
      } else {
        input.closest('form').find('#section-' + identifier).closest('.questions-wrapper').remove();
      }
    }).find('input').on('click', function(event) {
      var exportOption = jQuery(this).closest('.export-option');
      event.stopPropagation();
      event.preventDefault();
      setTimeout(function() { exportOption.trigger('click') }, 100);
      return false;
    });


  },

  initEvalResult: function(){
    var table = $('table.evaluation-result-listing');
    
    jQuery('.result-wrapper').append(SmartME.loadingIndicator());

    var initResultTable = function(data){
      var options = {
        data: data,
        info: false,
        lengthChange: false,
        language: {
          searchPlaceholder: I18n.t('search')
        },
        paging: false,
        autoWidth: false,
        sort: false,
        columnDefs: [
          { 
            type: "html", 
            render: function ( data, type, full, meta ) {
              if (data.search(/data-url/) == -1) {
                return data;
              }
              else {
                return jQuery('<a/>')
                  .addClass('modal-dialog-link')
                  .attr('data-modal-class', true)
                  .attr('data-hide-buttons', true)
                  .attr('data-title', I18n.t('evaluation_criterion_result'))
                  .text($(data).text())
                  .attr('href', $(data).data('url'))[0].outerHTML;
              }
            },
            targets: Array.apply(null, {length: table.data('eval-count') + 1}).map(Number.call, Number)
          },
        ]
      };

      $('table.evaluation-result-listing').dataTable(options);
    }

    var initRadioTable = function(data){
      var table = jQuery('.evaluation-radio-listing')
      var options = {
        data: data,
        info: false,
        lengthChange: false,
        language: {
          searchPlaceholder: I18n.t('search')
        },
        paging: false,
        autoWidth: false,
        sort: true,
        columnDefs: [
          {
            type: "html",
            render: function( data, type, full, meta) {
              if (type == 'display'){
                return data 
              }
            },
            targets: Array.apply(null, {length: table.data('eval-count') + 1}).map(Number.call, Number)
          }
        ]
      }

      $('table.evaluation-radio-listing').dataTable(options);

      var originalTitle = $('#copy-questions').attr('title');
      jQuery('#copy-questions').tooltip();

      jQuery('#copy-questions').on('click', function(e){
        e.stopPropagation();
        e.preventDefault();
        copyToClipboard(jQuery('.evaluation-radio-listing > tbody > tr > td:first-child').map(function(_, ele){ return $(ele).text() }).toArray().join('\n'));


        $('#copy-questions').attr('title', 'Copied')
          .tooltip('fixTitle')
          .tooltip('show');

          window.setTimeout(function(){
            $('#copy-questions').attr('title', originalTitle)
            .tooltip('fixTitle')
            .tooltip('hide');  
          }, 1000);

      });

    }


    jQuery.get(project_call_evaluation_result_data_path({note_id: table.data('note-id'), phase_id: table.data('phase-id')}), function(response){
      initResultTable(response.data);
      if (response.radioSelections)
        initRadioTable(response.radioSelections);

      SmartME.removeLoadingIndicator('.result-wrapper');
    });

  },

  archiveFileOptions: function(){
    var container = jQuery('.indicator-linking-container');
    var updateSelections = function() {
      // Show indicator and subgroup column content based on
      // project/indicator selection
      container.find('.column').not('.projects').each(function() {
        var col = jQuery(this);
        col.find('.no-selection').hide();
        col.find('.filtered-content').each(function() {
          var fc = jQuery(this);
          if (container.find('a.active[data-id="' + fc.attr('data-id') + '"]').length > 0) {
            fc.show();
          } else {
            fc.hide();
          }
        });
        if (col.find('.filtered-content > *:visible').length == 0) {
          col.find('.no-selection').show();
        }
      });
      // Mark project links linked if any of its indicator are selected
      container.find('.column.projects li a').removeClass('linked').each(function() {
        if (container.find('.column.indicators .filtered-content[data-id="' + jQuery(this).attr('data-id') + '"] a.linked').length > 0) {
          jQuery(this).addClass('linked');
        }
      });
    };
    container.on('click', '.projects a, .indicators a', function() {
      var a = jQuery(this);
      if (a.is('.indicators a')) {
        a.toggleClass('linked')//.closest('ul').find('a').not(this).removeClass('linked');
        var projectContext = a.closest('.filtered-content');
        // Disable all indicators on this project and enable this one (if active).
        // projectContext.find('[data-indicator-link]').prop('disabled', true);
        a.parent().find('[data-indicator-link]').prop('disabled', !a.is('.linked'));
        // Disable all subgroups on this project and enable subgroups of this indicator (if active)
        // container.find('.subgroups .filtered-content[data-id="' + projectContext.attr('data-id') + '"] [data-subgroup-link]').prop('disabled', true);
        // container.find('[data-subgroup-link="' + a.attr('data-indicator-id') + '"]').prop('disabled', !a.is('.active'));
      }
      else{
        a.toggleClass('active').closest('ul').find('a').not(this).removeClass('active');
      }
      updateSelections();
      return false;
    });
    jQuery('#select-all').on('click', function(){
      jQuery('.filtered-content[style*="display: block"] a').not('.disabled-link').each(function(){
        var a = jQuery(this)
        a.addClass('linked');
        a.parent().find('[data-indicator-link]').prop('disabled', !a.is('.linked'));
      })
      updateSelections();
    })
    jQuery('#unselect-all').on('click', function(){
      jQuery('.filtered-content[style*="display: block"] a').each(function(){
        var a = jQuery(this)
        a.removeClass('linked');
        a.parent().find('[data-indicator-link]').prop('disabled', !a.is('.linked'));
      })
      updateSelections();
    })
    updateSelections();
    container.find('.column.projects a.linked').first().trigger('click');
  },

  initBetaModalFunc: function(){
    function handleModalClick(link){
      var dialog = jQuery('#modal-dialog');
      var modalBody = dialog.find('.modal-body');
      var primaryButton = dialog.find('.modal-footer button.btn-primary');
      dialog.find('.modal-footer').show();
      dialog.find('.modal-title').html(link.data('title'));
      modalBody.html(SmartME.loadingIndicator());
      primaryButton.html(link.attr('data-save-label'));
      primaryButton.button('reset').removeAttr('disabled');
      
      dialog.modal();

      jQuery.ajax({
        url: link.attr('href'),
        method: 'POST',
        dataType: 'html',
      })
      .done(function(dialogContent) {
        modalBody.html(dialogContent);
        
        primaryButton.off('click').on('click', function() {
        jQuery(this).button('loading');
          var form = modalBody.find('form');
          jQuery.ajax({
            url: form.attr('action'),
            method: 'POST',
            dataType: 'html',
            data: form.serialize()
          })
          .done(function(dialogContent) {
            modalBody.html(dialogContent);
            if (dialog.find('.form-errors').length) {
              primaryButton.button('reset').removeAttr('disabled');
            } else
                dialog.find('.modal-footer').hide();
          });
          return false;
        });
      });

      dialog.trigger('modal:opened');
    }

    $('.email-feedback-button').on('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        handleModalClick($('#beta-feedback-dialog-button'));
    });

    $('.email-feedback-button').hover(
      function() {
          $(this).append(`<div class="hover-text">${I18n.t('click_feedback_prompt')}</div>`);
          $(this).parent().css('background-color', 'white');
      },
      function() {
          $(this).find('.hover-text').remove();
          $(this).parent().css('background-color', '');
      }
    );
  },

  priv: {
    initEvaluationList: function() {
      var options = {
        serverSide: true,
        ajax: function (data, callback, settings) {
          // add evaluation filters to the ajax data
          var extraParams = {
            "evaluation_filter_published": $('input[name="evaluation_list_filter[published]"]').is(':checked'),
            "evaluation_filter_pending": $('input[name="evaluation_list_filter[pending]"]').is(':checked'),
            "evaluation_filter_other": $('input[name="evaluation_list_filter[other]"]').is(':checked'),
            "visible_rv_columns": ActionJS.Project.priv.getVisibleColumns()
          };

          if ($('input[name^="evaluation_list_filter"]').length > 0) {
            sessionStorage.setItem('evaluationFilters-' + $('.concept-notes').data('selected-phase-id'), JSON.stringify(extraParams));
          }

          // jQuery.ajax({
          //   url: project_evaluation_list_page_legacy_path({
          //     format: 'json',
          //     call_id: $('.concept-notes').data('call-id'),
          //     phase_id: $('.concept-notes').data('selected-phase-id')
          //   }),
          //   type: 'post',
          //   data: $.extend({}, data, extraParams)
          // }).done(function(data) {
          //   ActionJS.Project.priv.filteredProjectIds = data.filteredProjectIds;
          //   callback(data);
          // })
        },
        // deferRender: true,
        sorting: [[1, 'asc']],
        // info: true,
        lengthChange: true,
        language: {
          searchPlaceholder: I18n.t('search')
        },
        lengthMenu: [ [20, 50, -1], [20, 50, I18n.t('all')] ],
        pageLength: 20,
        autoWidth: false,
        searching: true,
        searchDelay: 1200,
        stateSave: true,
        processing: true,
        select: {
          style:    'multi',
          selector: 'td:first-child'
        },
        columnDefs: [
          {
            render: function(data, type, rowData) {
              if (type == 'display') {
                var url = project_show_path({note_id: data.id, phase_id: jQuery('table.concept-notes').data('selected-phase-id'), format: null});
                var $projectLink = jQuery('<a>').attr('href', url).text(data.label);
                return jQuery('<div>').append($projectLink).html();
              }
              return data.label;
            },
            width: '120px',
            targets: [1]
          },
          {
            sortable: false,
            width: '20px',
            className: 'select-checkbox',
            targets: [0]
          },
          {
            render: function(data, type, rowData) {
              data = data || {};
              if (type == 'display') {
                var $container = jQuery('<div>').addClass('result-content');
                if (data.balance > 0) {
                  $container.append(jQuery('<i>').addClass('fa fa-thumbs-up'));
                }
                else if (data.balance < 0) {
                  $container.append(jQuery('<i>').addClass('fa fa-thumbs-down'));
                }
                else if (data.balance == 0) {
                  $container.append(jQuery('<i>').addClass('fa fa-plus'));
                }
                return jQuery('<div>').append($container).html();
              }
              return data.balance || '';
            },
            width: '90px',
            className: 'result-cell',
            targets: jQuery('table.concept-notes').data('result-column')
          },
          {
            render: function(data, type, rowData) {
              if (type == 'display') {
                return ActionJS.Project.priv.assignmentCellContent(data);
              }

              return (data.selected ? (data.result == 'yes' ? '3' : (data.result == 'no' ? '2' : '1')) : '0');
            },
            width: '40px',
            sortable: true,
            className: 'evaluator-cell',
            targets: jQuery('table.concept-notes').data('evaluator-columns')
          },
          {
            render: function(data, type, rowData) {
              return data.average;
            },
            sortable: true,
            width: '60px',
            className: 'average-cell',
            targets: jQuery('table.concept-notes').data('average-column')
          },
          {
            className: 'decision-cell',
            width: '115px',
            targets: jQuery('table.concept-notes').data('proceed-column')
          },
          {
            sortable: true,
            width: '20px',
            targets: jQuery('table.concept-notes').data('published-column')
          },
          {
            className: 'variable-cell',
            targets: jQuery('table.concept-notes').data('variable-columns')
          },
          {
            render: function(data, type, rowData) {
              if (type == 'display') {
                var $container = jQuery('<div>').addClass('evaluation-title-container').attr('title', data);
                $container.html(data);
                return jQuery('<div>').append($container).html();
              }

              return data;
            },
            className: 'name-cell',
            targets: jQuery('table.concept-notes').data('name-column')
          },
          {
            visible: false,
            targets: ActionJS.Project.priv.getHiddenColumns()
          }
        ],
        createdRow: function( row, data, dataIndex ) {
          jQuery(row).attr('tabindex', 1);
          jQuery(row).attr('data-index', dataIndex++);
        },
        initComplete: function() {
          ActionJS.Project.priv.initVisibleColumns();
        },
        drawCallback: function() {
          DataTablesHelper.addColumnFilters(this);
        },
        footerCallback: function () {
          DataTablesHelper.togglePagination(this);
        },
   
        stateSaveParams: ActionJS.Project.saveState,
        stateLoadCallback: ActionJS.Project.loadState
      };

      if (jQuery('table.concept-notes').data('prescoring-column') != '') {
        options.columnDefs.push({
          render: function(data, type, rowData) {
            if (type == 'display') {
              return data.label;
            }
            return data.value;
          },
          targets: jQuery('table.concept-notes').data('prescoring-column')
        });
      }

      if (!$.fn.DataTable.isDataTable('table.concept-notes') && jQuery('table.concept-notes').length) {
        ActionJS.Project.priv.noteTable = jQuery('table.concept-notes').DataTable(options);
        DataTablesHelper.searchDelay(ActionJS.Project.priv.noteTable, 1000);

        ActionJS.Project.priv.noteTable.on("click", "th.select-checkbox", function() {
          if ($("th.select-checkbox").hasClass("selected")) {
              ActionJS.Project.priv.noteTable.rows().deselect();
              $("th.select-checkbox").removeClass("selected");
          } else {
              ActionJS.Project.priv.noteTable.rows().select();
              $("th.select-checkbox").addClass("selected");
          }
        }).on("select deselect", function() {
          if (ActionJS.Project.priv.noteTable.rows({
              selected: true
            }).count() !== ActionJS.Project.priv.noteTable.rows().count()) {
            $("th.select-checkbox").removeClass("selected");
          } else {
            $("th.select-checkbox").addClass("selected");
          }
        })
      }

      jQuery('table.concept-notes').on('init.dt order.dt', function(){
        // $('[data-toggle="tooltip"]').tooltip();  
      });

      $('[data-toggle="popover"]').on('click',function(e){
        e.preventDefault();
        e.stopPropagation();
        $('.popover').off('click');  
        $('.popover').on('click', function(e) {e.stopPropagation();});
      }).popover();

      // assigning evaluators
      jQuery(document).find('.concept-notes').delegate('.evaluator-assign-icon.unselect', 'click', function() {
        var container = jQuery(this).closest('.evaluator-assingment-container');
        if (!JSON.parse(decodeURIComponent(container.data('options')))['result'] || confirm(I18n.t('confirm_unselect_evaluator'))) {
          container.toggleClass('selected');
          ActionJS.Project.priv.unassignEvaluator(container);

          if (jQuery('table.concept-notes').length) {
            ActionJS.Project.priv.refreshResultCell(container.closest('tr'));
            var cell = jQuery('table.concept-notes').DataTable().cell($(this).closest('td')[0]);
            var cellData = cell.data();
            cellData.selected = false;
            cell.data(cellData).invalidate();
          } else {
            ActionJS.Project.priv.refreshResultCell(container.closest('.ag-row'));
          }
        }
      });
      jQuery(document).find('.concept-notes').delegate('.evaluator-assign-icon.select', 'click', function() {
        var container = jQuery(this).closest('.evaluator-assingment-container');
        container.toggleClass('selected');
        ActionJS.Project.priv.assignEvaluator(container);

        if (jQuery('table.concept-notes').length) {
          ActionJS.Project.priv.refreshResultCell(container.closest('tr'));
          var cell = jQuery('table.concept-notes').DataTable().cell($(this).closest('td')[0]);
          var cellData = cell.data();
          cellData.selected = true;
          cell.data(cellData).invalidate();
        } else {
          ActionJS.Project.priv.refreshResultCell(container.closest('.ag-row'));
        }
      });

      // Columns selector
      jQuery('.dropdown.variable-columns').on('click', 'input, label', ActionJS.Project.priv.updateVisibleColumns);

      // Details toggle
      jQuery('.toggle-evaluation-list-details').on('click', function() {
        var link = jQuery(this);
        var details = localStorageWithExpiry.getItem('evaluation-list-details') || '{}';
        var detailsRow = jQuery('.evaluation-listing-details');
        if (details.hidden) {
          detailsRow.show()
          link.text(link.attr('data-toggle-hide'));
          jQuery('#evaluations-table-wrapper').removeClass('expanded');
        } else {
          detailsRow.hide();
          link.text(link.attr('data-toggle-show'));
          jQuery('#evaluations-table-wrapper').addClass('expanded');
        }
        localStorageWithExpiry.setItem('evaluation-list-details', {hidden: details.hidden ? false : true});
        return false;
      });
      if (!(localStorageWithExpiry.getItem('evaluation-list-details') || '{}').hidden) {
        jQuery('.evaluation-listing-details').show();
        jQuery('#evaluations-table-wrapper').removeClass('expanded');
      } else {
        jQuery('.toggle-evaluation-list-details').text(jQuery('.toggle-evaluation-list-details').attr('data-toggle-show'))
      }
      // this.priv.initRowSelecting();
    },


    initFinalProjectList: function() {
      var options = {
        deferRender: true,
        data: jQuery('table.concept-notes').data('table-content'),
        sorting: [[1, 'desc']],
        info: true,
        lengthChange: true,
        language: {
          searchPlaceholder: I18n.t('search')
        },
        lengthMenu: [ [20, 50, -1], [20, 50, I18n.t('all')] ],
        pageLength: 20,
        autoWidth: false,
        columnDefs: [
          {
            render: function(data, type, rowData) {
              if (type == 'display') {
                var url = null;
                if (false) {
                  url = project_evaluate_path({note_id: data.id, phase_id: jQuery('table.concept-notes').data('selected-phase-id'), format: null});
                }
                else {
                  url = project_show_path({note_id: data.id, phase_id: jQuery('table.concept-notes').data('selected-phase-id'), format: null});
                }
          
                var $projectLink = jQuery('<a>').attr('href', url).text(data.label);
                return jQuery('<div>').append($projectLink).html();
              }
              return data.label;
            },
            width: '120px',
            targets: [0]
          },
          {
            visible: false,
            targets: ActionJS.Project.priv.getHiddenColumns()
          },
          {
            render: function(data, type, rowData) {
              if (type == 'display') {
                return data.label;
              } else if (data.multiple_values) {
                return DataTablesHelper.formatMultipleSearchData(data.multiple_values);
              }
              return data.order;
            },
            targets: jQuery('table.concept-notes').data('variable-columns')
          }
        ],
        createdRow: function( row, data, dataIndex ) {
          jQuery(row).attr('tabindex', 1);
          jQuery(row).attr('data-index', dataIndex++);
        },
        initComplete: function() {
          DataTablesHelper.addColumnFilters(this);
        },
        footerCallback: function () {
          DataTablesHelper.togglePagination(this);
        }
      };
      if (!$.fn.DataTable.isDataTable('table.concept-notes')){
        ActionJS.Project.priv.noteTable = jQuery('table.concept-notes').DataTable(options);
      }

      $('table.concept-notes').delegate('.monitoring-decision-checkbox', 'change', function() {
        var $cb = $(this);
        var projectId = $cb.data('project-id');
        var enableMonitoring = ($cb.is(':checked') ? 'true' : 'false');
        $cb.next('label').addClass('active');

        $.ajax({
          url: project_update_monitoring_status_path({
            'project_id': projectId,
            'monitoring_enabled': enableMonitoring
          }),
          method: 'post'
        }).done(function(data) {
          $cb.next('label').removeClass('active');
        }).error(function(data) {
          $cb.next('label').removeClass('active');
          alert('Error updating monitoring status');
        });
      });

      // Columns selector
      jQuery('.dropdown.variable-columns').on('click', 'input, label', ActionJS.Project.priv.updateVisibleColumns);
    },
    initDefaultProjectList: function() {
      var table = jQuery('table.concept-notes');
      var options = {
          serverSide: true,
          ajax: function (data, callback, settings) {
            jQuery.ajax({
              url: table.attr('data-url'),
              type: 'POST',
              data: $.extend({}, data, {visible_rv_columns: ActionJS.Project.priv.getVisibleColumns()})
            }).done(function(data) {
              ActionJS.Project.priv.filteredProjectIds = data.filteredProjectIds;
              callback(data);
            })
          },
          info: true,
          lengthChange: true,
          language: {
            searchPlaceholder: I18n.t('search')
          },
          pageLength: 50,
          autoWidth: false, 
          stateSave: true,
          processing: true,
          sorting: [[0, 'asc']],
          columnDefs: [
            {
              //id
              render: function(data,type, row, meta){
                return jQuery('#default-projects-list-identifier-template').html()
                .replace(/__id__/g, data.id)
                .replace(/__label__/g, data.label);
              },
              targets: DataTablesHelper.colIndex(table, 'identifier')
            },
            {
              visible: false,
              targets: ActionJS.Project.priv.getHiddenColumns()
            },  
            {
              //progress
              render: function(data, type, row, meta){
                if (type == 'display'){
                  return jQuery('#default-projects-list-progress-template').html().replace(/__scaled__/g, data);
                }
                else{
                  return data;
                }
              },
              //orderable: false,
              width: '95px',
              targets: DataTablesHelper.colIndex(table, 'progress')
            },
            {
              //extension
              render: function(data, type, row, meta){
                return data.extension_period 
                      ? data.extension_period['granted_until'] 
                      : (data.permission 
                          ? jQuery('#default-projects-list-extension-template').html().replace(/__id__/g, data.id).replace(/__phase_id__/g, data.phase_id)
                          : '-');
              },
              targets: DataTablesHelper.colIndex(table, 'extension')
            },
            {
              //status
              render: function(data, type, row, meta){
                if (data.undo_status) {
                  return jQuery('#default-projects-list-status-template').html()
                          .replace(/__id__/g, data.id)
                          .replace(/__phase_id__/g, data.phase_id)
                          .replace(/__status__/g, I18n.t("concept_note_status_" + data.status));
                }
                else{
                  return I18n.t("concept_note_status_" + data.status);
                }
              },
              targets: DataTablesHelper.colIndex(table, 'status'),
              className: 'status-cell'

            },
            {
              //brokers
              render: function(data, type, row, meta){
                if (type == 'display') {
                  var elem = jQuery('<div>').append(jQuery('<i>').addClass('assign fa ' + (data ? 'fa-circle selected' : 'fa-circle-o not-selected'))).html();;
                  console.log(elem);
                  return elem;
                }

                return  data ? 'x' : '';
              },
              targets: function(){ 
                return jQuery(table).find(' th[data-col$="-brokers"]').map(function(idx, a){
                  return parseInt(a.getAttribute('data-col').replace(/^(\d+)-.+$/, '$1'), 10);
                }).toArray();
              }(),
              width: 30,
              className: 'assignment-cell'
            },
            {
              render: function(data, type, row, meta){
                return data
              },
              targets: 1,
              className: 'wrap-visible-text'
            },
            {
              //varible
              render: function(data, type, row, meta){
                var d = data || {label: null, order: 0}
                if (type == 'display') {
                  return d.label;
                } else if (d.multiple_values) {
                  return DataTablesHelper.formatMultipleSearchData(d.multiple_values);
                }
                return d.order;
              },
              targets: function(){
                let index_array = []
                for (let i=2;i<DataTablesHelper.colIndex(table, 'status');i++){
                  index_array.push(i)
                }
                return index_array
              }()
            }
          ],
          initComplete: function() {
            ActionJS.Project.priv.initVisibleColumnsNew();
          },
          drawCallback: function(){
            DataTablesHelper.addColumnFilters(this);
          },
          footerCallback: function () {
            DataTablesHelper.togglePagination(this);
          },
          stateSaveParams: ActionJS.Project.saveState,
          stateLoadCallback: ActionJS.Project.loadState
      };
      if (!$.fn.DataTable.isDataTable('table.concept-notes')){
        ActionJS.Project.priv.noteTable = jQuery('table.concept-notes').DataTable(options);
        DataTablesHelper.searchDelay(ActionJS.Project.priv.noteTable, 1000);
      }
      //Columns selector
      jQuery('.dropdown.variable-columns').on('click', 'input, label', ActionJS.Project.priv.updateVisibleColumnsNew);
    },

    assignmentCellContent: function(data) {
      var template = jQuery('#evaluation-cell').html();
        var color = "", style = "fa-circle";
        if (data.result == 'draft') {style = 'fa-circle';}
        else if (data.result == 'yes') {color = 'green';}
        else if (data.result == 'no') {color = 'red';}
        else {style = "fa-circle-o";}

      template = template
        .replace('__editable__', (data.may_edit ? 'editable' : ''))
        .replace('__pending-prescoring__', data.pending_prescoring ? 'pending-prescoring' : '')
        .replace('__data-options__', encodeURIComponent(JSON.stringify(data)))
        .replace('__selected__', data.selected ? 'selected' : '')
        .replace('__has-score__', data.score ? '' : 'hidden')
        .replace('__has-not-score__', data.score ? 'hidden' : '')
        .replace('__result__', (data.result == 'yes' ? 'green' : (data.result == 'no' ? 'red' : '')))
        .replace('__score__', data.score || '')
        .replace('__style__', style || '')
        .replace('__color__', color || '')

      return template;
    },


    unassignEvaluator: function(assignmentContainer){ 
      var data = JSON.parse(decodeURIComponent(assignmentContainer.data('options')))
      data['selected'] = true;

      jQuery.ajax({
        url: project_unassign_evaluator_path({person_id: data.person_id,
          project_id: data.project_id, phase_id: jQuery('.concept-notes').data('selected-phase-id'), format: null}),
        method: 'post'
      }).error(function(data, textStatus) {
        assignmentContainer.addClass('selected');
        data['selected'] = true;
        alert(I18n.t('error_updating_evaluator_assignment'));
      });
    },

    assignEvaluator: function(assignmentContainer) {
      var data = JSON.parse(decodeURIComponent(assignmentContainer.data('options')))
      data['selected'] = true;
      jQuery.ajax({
        url: project_assign_evaluator_path({person_id: data.person_id,
          project_id: data.project_id, phase_id: jQuery('.concept-notes').data('selected-phase-id'), format: null}),
        method: 'post'
      }).done(function(response) {
        if (response.status === 'error') {
          assignmentContainer.toggleClass('selected');
          data['selected'] = false;
          
          // // Also revert DataTable cell data if using DataTables
          // if (jQuery('table.concept-notes').length) {
          //   var cell = jQuery('table.concept-notes').DataTable().cell(assignmentContainer.closest('td')[0]);
          //   var cellData = cell.data();
          //   if (typeof cellData === 'object' && cellData !== null) {
          //     cellData.selected = false;
          //     cell.data(cellData).invalidate();
          //   }
          //   ActionJS.Project.priv.refreshResultCell(assignmentContainer.closest('tr'));
          // } else {
          //   ActionJS.Project.priv.refreshResultCell(assignmentContainer.closest('.ag-row'));
          // }
          
          alert(response.message || I18n.t('error_updating_evaluator_assignment'));
        }
      }).error(function(data, textStatus) {
        assignmentContainer.removeClass('selected');
        data['selected'] = false;
        
        // // Also revert DataTable cell data if using DataTables
        // if (jQuery('table.concept-notes').length) {
        //   var cell = jQuery('table.concept-notes').DataTable().cell(assignmentContainer.closest('td')[0]);
        //   var cellData = cell.data();
        //   if (typeof cellData === 'object' && cellData !== null) {
        //     cellData.selected = false;
        //     cell.data(cellData).invalidate();
        //   }
        //   ActionJS.Project.priv.refreshResultCell(assignmentContainer.closest('tr'));
        // } else {
        //   ActionJS.Project.priv.refreshResultCell(assignmentContainer.closest('.ag-row'));
        // }
        
        alert(I18n.t('error_updating_evaluator_assignment'));
      });
    },

    refreshResultCell: function($row) {
      var $resultContainer = $row.find('.result-content');
      var $i = jQuery('<i>').addClass('fa');
      var c = ActionJS.Project.priv.countItemInArray;

      var results = $row.find('.evaluator-assingment-container.selected').map(function(i,e){
        return JSON.parse(decodeURIComponent($(this).data('options')))['result'];
      });

      if (results.length == 0) {
        //$i.addClass('fa-plus');
      }
      else if (c(results, '') > 0) {
        $i = '';
      }
      else if (c(results, 'yes') > c(results, 'no')) {
        $i.addClass('fa-thumbs-up');
      }
      else if (c(results, 'yes') < c(results, 'no')) {
        $i.addClass('fa-thumbs-down');
      }
      else {
        $i.addClass('fa-plus');
      }
      $resultContainer.html('');
      $resultContainer.append($i);
    },


    initRowSelecting: function() {
      // selecting rows
      jQuery('table.concept-notes tbody tr').on('mousedown', function(e){
        if (e.button != 0) return false;

        if (!e.metaKey && !e.ctrlKey && !e.shiftKey) {
          jQuery('table.concept-notes tbody tr').removeClass('selected');
        }

        if (e.shiftKey) {
          var targetIndex = jQuery(e.currentTarget).data('index');
          var targetItem = jQuery('table.concept-notes tbody tr.focus').nextAll('[data-index="'+targetIndex+'"]');

          if (targetItem.length > 0) {
            jQuery('table.concept-notes tbody tr.focus').nextUntil('[data-index="'+targetIndex+'"]').addClass('selected');
          }
          else {
            jQuery('table.concept-notes tbody tr.focus').prevUntil('[data-index="'+targetIndex+'"]').addClass('selected');  
          }
        }

        jQuery('table.concept-notes tbody tr').removeClass('focus');
        jQuery(this).addClass('selected focus');
      });
    },

    countItemInArray: function(array, v) {
      var cnt = 0;
      for (var i = 0 ; i < array.length ; i++) {
        if (array[i] == v) cnt++;
      }
      return cnt;
    },

    syncTitleWidths: function() {
      if ($('.evaluation-listing-header-placeholder').length > 0) {
        ActionJS.Project.priv.initVisibleColumns();

        $('table.concept-notes thead th').each(function(i,e) {
          var targetCell = $('div.concept-note-titles div.title-container:visible').eq(i);
          targetCell.css({
            padding: $(this).css('padding')
          });
          targetCell.width($(this).width());

          if ($(this).is('.sorting_asc')) {
            targetCell.addClass('asc');
          }
          else if ($(this).is('.sorting_desc')) {
            targetCell.addClass('desc');
          }
        });

        var areaWidth = $(window).width()-$('.sidebar').width();
        var headerRowWidth = $('.title-container:visible').map(function(){
            return jQuery(this).outerWidth();
          }).get().reduce(function(a,b){return a+b;});

        areaWidth = (areaWidth < 800 ? 800 : areaWidth);

        // table width
        if (areaWidth < headerRowWidth) {
          jQuery('body').width(parseInt(headerRowWidth)+$('.sidebar').width());
        }
        else {
          jQuery('body').width('auto');
        }

        $('.evaluation-listing-header-placeholder').height($('.evaluation-listing-header').height()-$('.concept-notes thead').height());
      }
    },
    syncTitlePosition: function() {

      if ($('.evaluation-listing-header-placeholder').length > 0) {
        var top = $('.evaluation-listing-header-placeholder').offset().top - $(window).scrollTop() - $('.navbar').height() - $('.breadcrumb').height();
        if (top < 0) {
          $('.evaluation-listing-header').css({top: -top + 'px'});
        }
        else {
          $('.evaluation-listing-header').css('top', '0');
        }
      }
    },

    initCustomSortIcons: function() {
      $('.concept-note-titles').delegate('.title-container', 'click', function() {
        var idx = $('.concept-note-titles .title-container').index(this);
        var dir = ($(this).is('.asc') ? 'desc' : 'asc');
        
        $('.concept-note-titles .title-container').removeClass('asc desc');
        $(this).addClass(dir);
        $('table.concept-notes').DataTable().order([idx, dir]).draw();
      });
    },

    initEvaluationFilters: function() {
      try {
        var filters = $.parseJSON(sessionStorage.getItem('evaluationFilters-'+ $('.concept-notes').data('selected-phase-id')));

        $.each(filters, function(k,v) {
          $('#' + k).prop('checked', v);          
        });
      }
      catch(e) {
        // console.log("Evaluation filters not saved.");
      }
    },

    initProjectHeaderTabs: function(){
      $('ul.project-title-tabs a.async').off('click').on('click', function() {
        // Skip the confirmation for evaluation form
        if (ConfirmFormExit.contentChanged() && !$('form.concept-evaluation-form').length) {
          return confirm(I18n.t('confirm_exit_without_saving'));
        }
      });

      var selected = jQuery('ul.project-title-tabs .selected > a');

      if (selected.length == 0) {
        selected = jQuery('ul.project-title-tabs a.async:first');
        selected.closest('li').addClass('selected');
      }

      ActionJS.Project.priv.setProjectTabContent(SmartME.loadingIndicator());

      var url = selected.data('init-url') || selected.data('url')

      $.get(url, function(content) {
        ActionJS.Project.priv.setProjectTabContent(content);
        ConfirmFormExit.reload();
      });
    },

    setProjectTabContent: function(content,target){
       target = target || $('div.async-container .container-fluid:first');
      target.html(content);
      ActionJS.Project.priv.initializeProjectTab();
      // $(document).trigger('projectPage:load');
    },

    initializeProjectTab: function(){
      $('.main').on('click', '.undo-evaluation-submit', function(e) {
          var $link = $(this);
          
        ExplanationDialog.open(function(explanation){

          $.ajax({
            url: project_undo_evaluation_path({
              project_id: $link.data('project-id'),
              content_id: $link.data('content-id'),
              explanation: explanation
            }),
            method: 'post'
          }).done(function(content) {
            $link.closest('td').html(I18n.t('evaluation_status_draft'));
            ExplanationDialog.close();
          });
        }, '<p>' + I18n.t('undo_evaluation_submit_confirm') + '</p>');

        e.preventDefault();
        return false;
      });

      $('[data-toggle="tooltip"]').tooltip();
    },

    initProgressRequirement: function() {
      // Add delay to ensure DOM is fully loaded
      setTimeout(function() {
        var proceedAnswered = ($('[name="evaluation[recommend_proceeding]"],[name="evaluation[recommended]"]').serialize().length > 0);
        jQuery('.btn.btn-publish').toggleClass('disabled', !proceedAnswered);
        if (proceedAnswered) jQuery('.btn.btn-publish').closest('div').tooltip('destroy').removeAttr('data-toggle');
      }, 100);
    },

    updateVisibleColumns: function(e) {
      var elem = jQuery(this);

      if (elem.is('input')) {
        var dropdown = elem.closest('.variable-columns');
        var index = parseInt(elem.attr('data-index'), 10);
        var visible = elem.prop('checked');
        var ids = [];
        dropdown.find('input:checked').each(function() { ids.push(this.value); });

        ActionJS.Project.priv.noteTable.column(index).visible(visible);
        ActionJS.Project.priv.noteTable.draw();
        jQuery('.concept-note-titles .title-container:eq(' + index + ')').css('display', visible ? 'inline-block' : 'none');
        ActionJS.Project.priv.syncTitleWidths();

        jQuery.post(dropdown.attr('data-url'), { report_variable_ids: ids });
      } else {
        elem.find('input').trigger('click');
        return false;
      }

      e.stopPropagation();
    },

    updateVisibleColumnsNew: function(e){
      //update visiblecolumns
      var elem = jQuery(this);

      if (elem.is('input')) {
        var dropdown = elem.closest('.variable-columns');
        var index = parseInt(elem.attr('data-index'), 10);
        var visible = elem.prop('checked');
        var ids = [];
        dropdown.find('input:checked').each(function() { ids.push(this.value); });

        ActionJS.Project.priv.noteTable.column(index).visible(visible);
        ActionJS.Project.priv.noteTable.draw();

        jQuery('.concept-notes .thead th:eq(' + index + ')').css('display', visible ? 'table-cell' : 'none');

        jQuery.post(dropdown.attr('data-url'), { report_variable_ids: ids });
      } else {
        elem.find('input').trigger('click');
        return false;
      }

      e.stopPropagation();
    },

    getHiddenColumns: function() {
      var hiddenColumns = [];
      jQuery('.dropdown.variable-columns input:not(:checked)').each(function() {
        hiddenColumns.push(parseInt(this.getAttribute('data-index'), 10));
      });
      return hiddenColumns;
    },
    
    getVisibleColumns: function() {
      var visibleColumns = [];
      jQuery('.dropdown.variable-columns input:checked').each(function() {
        visibleColumns.push(parseInt(this.getAttribute('value'), 10));
      });
      return visibleColumns;
    },

    initVisibleColumns: function() {
      jQuery('.dropdown.variable-columns input').each(function() {
        var index = parseInt(this.getAttribute('data-index'), 10);
        var visible = jQuery(this).is(':checked');
        ActionJS.Project.priv.noteTable.column(index).visible(visible);
        jQuery('.concept-note-titles .title-container:eq(' + index + ')').css('display', visible ? 'inline-block' : 'none');
        jQuery('.concept-notes .thead th:eq(' + index + ')').css('display', visible ? 'table-cell' : 'none');

      });
    },

    initVisibleColumnsNew: function(table){
      jQuery('.dropdown.variable-columns input').each(function() {
        var index = parseInt(this.getAttribute('data-index'), 10);
        var visible = jQuery(this).is(':checked');
        ActionJS.Project.priv.noteTable.column(index).visible(visible);
        jQuery('.concept-notes-new .thead th:eq(' + index + ')').css('display', visible ? 'table-cell' : 'none');
      });
    },

    initRevertSubmit: function(cb) {
      $('body').on('click', '.undo-project-submit', function(e) {
        
        var $link = jQuery(this);

        ExplanationDialog.open(function(explanation){
          $.ajax({
            url: project_undo_submit_path({
              project_id: $link.data('project-id'),
              phase_id: $link.data('phase-id'),
              explanation: explanation
            }),
            method: 'post',
            async: true
          }).done(function(content) {
            cb($link);
            ExplanationDialog.close()
          });
        }, '<p>' + I18n.t('undo_form_submit_confirm') + '</p>')  

        

        e.preventDefault();
        return false;
      });
    }
  }
};
